<sf-loader></sf-loader>
<sf-notification></sf-notification>
<sf-grid-generic-basic [list]="list" [languageCode]="language" [flUpdate]="flUpdate" [btnNewLabel]="btnNewLabel" [dialogHeader]="dialogHeader" (choosedType)="reciverFeedbackType($event)" (choosedItem)="reciverFeedbackItem($event)"></sf-grid-generic-basic>